<script setup>
/**
 * Comando de macro de pagamento do atendente (SuperTVGo) —
 * `/macroComprarUniTVMensal`, `/macroRenovarIPTVTrimestral <conta>` etc.
 *
 * O backend (rota `/webhooks/chatwoot`) reescreve o `content` desta mensagem
 * conforme o processamento avança — mesmo mecanismo do painel de raciocínio
 * (`AgentReasoning.vue`): a API do Chatwoot só deixa atualizar `content`
 * depois que a mensagem existe, `content_attributes` é ignorado no PATCH,
 * então o estado vai num marcador HTML na primeira linha do texto.
 *
 * Estados: pendente (job na fila/rodando) -> concluido (balões de pagamento
 * já mandados pro cliente) ou erro (ferramenta recusou, motivo foi pra nota
 * interna do ticket).
 */
import { computed } from 'vue';
import BaseBubble from 'next/message/bubbles/Base.vue';
import { useMessageContext } from '../provider.js';

const { content } = useMessageContext();

const MARCADOR = /^<!--supertvgo_macro:(pendente|concluido|erro)-->\n?/;

const estado = computed(
  () => MARCADOR.exec(content.value ?? '')?.[1] ?? 'pendente'
);

const comando = computed(() => (content.value ?? '').replace(MARCADOR, ''));
</script>

<template>
  <BaseBubble
    class="![background-color:rgb(var(--teal-9))] ![color:rgb(var(--teal-12))] px-3 py-2"
  >
    <div class="flex items-center gap-2 font-mono text-sm">
      <span
        v-if="estado === 'pendente'"
        class="i-lucide-loader-circle animate-spin size-4 flex-shrink-0"
      />
      <span
        v-else-if="estado === 'concluido'"
        class="i-lucide-check size-4 flex-shrink-0"
      />
      <span v-else class="i-lucide-triangle-alert size-4 flex-shrink-0" />
      <span>{{ comando }}</span>
    </div>
  </BaseBubble>
</template>
